var helperTextSlot = 'fx_2d2fb1e5_nn1muy0';

export { helperTextSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
